(function () {
  function formatMoney(amount, moneyFormat) {
    return (moneyFormat || '${{amount}}')
      .replace('{{amount}}', amount.toFixed(2))
      .replace('{{amount_no_decimals}}', Math.round(amount).toString())
      .replace('{{amount_with_comma_separator}}', amount.toFixed(2).replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(amount).toString());
  }

  function getApplicableTier(qty, tiers) {
    return tiers.reduce((best, tier) => (qty >= tier.min_qty ? tier : best), tiers[0]);
  }

  function applyMOQ(sectionId) {
    const tiers = window.priceTiers;
    if (!tiers || !tiers.length) return;
    const selector = sectionId ? `#Quantity-${sectionId}` : '[name="quantity"]';
    const input = document.querySelector(selector);
    if (!input) return;
    const moq = tiers[0].min_qty || 1;
    // Set both min and data-min so Dawn's setQuantityBoundries() reads the
    // correct MOQ value regardless of script execution order
    input.min = moq;
    input.dataset.min = moq;
    if (!input.value || parseInt(input.value) < moq) input.value = moq;
  }

  class PriceTierTable {
    constructor(wrapper) {
      this.wrapper = wrapper;
      this.sectionId = wrapper.dataset.sectionId;
      this.moneyFormat = wrapper.dataset.moneyFormat || '${{amount}}';
      this.tiers = null;
      this.qtyBound = false;
    }

    getTiersFromDOM() {
      const el = document.getElementById(`PriceTiersData-${this.sectionId}`);
      if (!el) return null;
      try {
        const parsed = JSON.parse(el.textContent.trim());
        return Array.isArray(parsed) && parsed.length ? parsed : null;
      } catch (e) {
        return null;
      }
    }

    render() {
      const table = this.wrapper.querySelector('.pricing-tiers');
      if (!table) return;
      const thead = document.createElement('thead');
      const tbody = document.createElement('tbody');
      const headerRow = document.createElement('tr');
      const bodyRow = document.createElement('tr');
      this.tiers.forEach((tier) => {
        const th = document.createElement('th');
        th.dataset.minQty = tier.min_qty;
        th.textContent = `${tier.min_qty}+`;
        headerRow.appendChild(th);
        const td = document.createElement('td');
        td.dataset.minQty = tier.min_qty;
        td.textContent = `$${tier.price}`;
        bodyRow.appendChild(td);
      });
      thead.appendChild(headerRow);
      tbody.appendChild(bodyRow);
      table.appendChild(thead);
      table.appendChild(tbody);
    }

    updateMainPrice(tier, qty) {
      const priceContainer = document.querySelector(`#price-${this.sectionId}`);
      if (!priceContainer) return;
      // Show total (unit price × qty) in whichever price element is rendered
      const targets = [
        priceContainer.querySelector('.price__regular span.price-item--regular'),
        priceContainer.querySelector('.price-item--sale.price-item--last'),
      ];
      targets.forEach((el) => {
        if (el) el.textContent = formatMoney(tier.price * qty, this.moneyFormat);
      });
    }

    highlight() {
      if (!this.tiers) return;
      const qtyInput = document.querySelector(`#Quantity-${this.sectionId}`);
      const moqFloor = this.tiers[0]?.min_qty || 1;
      const qty = parseInt(qtyInput?.value) || moqFloor;
      const tier = getApplicableTier(qty, this.tiers);

      this.wrapper.querySelectorAll('[data-min-qty]').forEach((cell) => {
        cell.classList.toggle(
          'price-tiers__col--active',
          parseInt(cell.dataset.minQty) === tier.min_qty
        );
      });

      const unitEl = this.wrapper.querySelector('.price-tiers__unit-label');
      const totalEl = this.wrapper.querySelector('.price-tiers__total-label');
      if (unitEl) unitEl.textContent = `${formatMoney(tier.price, this.moneyFormat)} / item`;
      if (totalEl) totalEl.textContent = `Total: ${formatMoney(tier.price * qty, this.moneyFormat)}`;

      this.updateMainPrice(tier, qty);
    }

    bindTierClicks() {
      const qtyInput = document.querySelector(`#Quantity-${this.sectionId}`);
      if (!qtyInput) return;
      this.wrapper.querySelectorAll('[data-min-qty]').forEach((cell) => {
        cell.addEventListener('click', () => {
          qtyInput.value = parseInt(cell.dataset.minQty);
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    }

    bindTierHover() {
      this.wrapper.querySelectorAll('[data-min-qty]').forEach((cell) => {
        cell.addEventListener('mouseenter', () => {
          this.wrapper
            .querySelectorAll(`[data-min-qty="${cell.dataset.minQty}"]`)
            .forEach((c) => c.classList.add('price-tiers__col--hover'));
        });
        cell.addEventListener('mouseleave', () => {
          this.wrapper
            .querySelectorAll(`[data-min-qty="${cell.dataset.minQty}"]`)
            .forEach((c) => c.classList.remove('price-tiers__col--hover'));
        });
      });
    }

    bindQtyInput() {
      if (this.qtyBound) return;
      const qtyInput = document.querySelector(`#Quantity-${this.sectionId}`);
      if (!qtyInput) return;
      this.qtyBound = true;
      // Update tier highlight live as the user types — no MOQ enforcement mid-keystroke
      // so typing "244" over "144" doesn't get stuck
      qtyInput.addEventListener('input', () => this.highlight());
      // Enforce MOQ only once the value is committed (blur/Enter both trigger 'change')
      qtyInput.addEventListener('change', () => {
        const moq = window.priceTiers?.[0]?.min_qty || 1;
        if (!qtyInput.value || parseInt(qtyInput.value) < moq) qtyInput.value = moq;
        this.highlight();
      });
    }

    init() {
      this.tiers = this.getTiersFromDOM();
      if (!this.tiers) {
        this.wrapper.hidden = true;
        return;
      }
      this.wrapper.hidden = false;
      window.priceTiers = this.tiers;
      this.render();
      this.bindTierClicks();
      this.bindTierHover();
      this.bindQtyInput();
      this.highlight();
      // Defer MOQ enforcement to run after product-info.js setQuantityBoundries()
      // finishes its own sync init (which resets value to data-min)
      setTimeout(() => {
        applyMOQ(this.sectionId);
        this.highlight();
      }, 0);
    }
  }

  const tables = {};

  function init() {
    document.querySelectorAll('[data-price-tiers]').forEach((wrapper) => {
      const id = wrapper.dataset.sectionId;
      tables[id] = new PriceTierTable(wrapper);
      tables[id].init();
    });
  }

  function bindVariantChange() {
    // PUB_SUB_EVENTS is defined with `const` in constants.js — not on window
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { sectionId } }) => {
      applyMOQ(sectionId);
      tables[sectionId]?.highlight();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      init();
      bindVariantChange();
    });
  } else {
    init();
    bindVariantChange();
  }
})();
